module.exports = __webpack_public_path__ + "assets/img/wicket.png?f36cd1ed3e183e8227a746cf1ce31d7b";